import { takeEvery, call, put, all, fork, select } from "redux-saga/effects";
import { FETCH_RESULT_TEST } from "./action";
import { actionCreators as actionCreatorsTest } from "../../test/action";
import reduxSagaFirebase from "../../common/reduxSagaFirebase";
import { actionCreators as actionCreatorsSpinner } from "../Spinner/action";

export function* onFetchResultSaga() {
  yield put(actionCreatorsSpinner.showSpinner());
  try {
    const uid = yield select((state) => state.user.user.uid);
    const answers = yield call(
      reduxSagaFirebase.database.read,
      `answers/${uid}`
    );
    yield put(actionCreatorsTest.saveTest(answers));
    yield put(actionCreatorsSpinner.hideSpinner());
  } catch (error) {
    yield put(actionCreatorsSpinner.hideSpinner());
  }
  //   yield put(actionCreators.spinnerOff());
}

export function* fetchResultSaga() {
  yield takeEvery(FETCH_RESULT_TEST, onFetchResultSaga);
}

export function* resultSaga() {
  yield all([fork(fetchResultSaga)]);
}
